import React, { useState, useCallback, lazy, Suspense } from 'react';
import cn from 'classnames';
import LazyImage from 'components/UI/LazyImage';
import Link from 'components/UI/Link';
import { useStateModal } from 'utils/hooks';
import { useCertificatesInfo } from 'staticQueries/certificates-info';

import * as styles from './Icons.module.scss';

const CertificateModal = lazy(() => import('components/Modals/CertificateModal'));

function Icons({ className, certificateIDs }) {
  const [state, setState] = useState();
  const { modalState, showModal, hideModal } = useStateModal();
  const certificates = useCertificatesInfo(certificateIDs);

  const callModal = useCallback(modalData => {
    setState(modalData);
    showModal(modalData?.modalName);
  }, []);

  return (
    <div className={cn(className, styles.iconsWrapper)}>
      {certificates.map(({ images, name, link, mods, modalData }) => {
        const { preview, modalWindow: imgForModal, alt } = images;
        const shouldShowModal = Boolean(modalData?.title);
        const preparedAlt = alt ?? name ?? modalData?.title ?? 'certificate';
        const preparedMods = mods?.map(mod => styles[mod]);

        const handleClickOnIcon = () => {
          callModal({
            ...modalData,
            img: imgForModal ?? preview,
            link,
          });
        };

        return (
          <div
            key={preview}
            className={cn(
              styles.item,
              mods && preparedMods,
              (link || shouldShowModal) && styles.link,
            )}
          >
            {!shouldShowModal && link ? (
              <Link href={link} className={styles.iconWrapper}>
                <LazyImage src={preview} alt={preparedAlt} className={styles.iconImg} />
              </Link>
            ) : (
              <div
                className={styles.iconWrapper}
                onClick={shouldShowModal ? handleClickOnIcon : undefined}
                role={shouldShowModal ? 'button' : null}
              >
                <LazyImage src={preview} alt={alt} className={styles.iconImg} />
              </div>
            )}
          </div>
        );
      })}
      <Suspense fallback={null}>
        <CertificateModal isOpen={modalState.isOpen} closeModalCallback={hideModal} {...state} />
      </Suspense>
    </div>
  );
}

export default React.memo(Icons);
